import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../chunks/tslib.es6.js";
import r from "../core/Error.js";
import { JSONSupport as e } from "../core/JSONSupport.js";
import { property as o } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import { ensureType as s } from "../core/accessorSupport/ensureType.js";
import { subclass as n } from "../core/accessorSupport/decorators/subclass.js";
import i from "./PortalQueryParams.js";

var l = /*#__PURE__*/function (_e) {
  _inherits(l, _e);

  var _super = _createSuper(l);

  function l(t) {
    var _this;

    _classCallCheck(this, l);

    _this = _super.call(this, t), _this.access = null, _this.created = null, _this.description = null, _this.id = null, _this.isInvitationOnly = !1, _this.modified = null, _this.owner = null, _this.portal = null, _this.snippet = null, _this.sortField = null, _this.sortOrder = null, _this.tags = null, _this.title = null;
    return _this;
  }

  _createClass(l, [{
    key: "thumbnailUrl",
    get: function get() {
      var t = this.url,
          r = this.thumbnail;
      return t && r ? this.portal._normalizeUrl("".concat(t, "/info/").concat(r, "?f=json")) : null;
    }
  }, {
    key: "url",
    get: function get() {
      var t = this.get("portal.restUrl");
      return t ? t + "/community/groups/" + this.id : null;
    }
  }, {
    key: "fetchCategorySchema",
    value: function fetchCategorySchema(t) {
      var _this2 = this;

      return this.portal._request(this.url + "/categorySchema", t).then(function (r) {
        var e = r.categorySchema || [];
        return e.some(function (t) {
          return "contentCategorySetsGroupQuery.LivingAtlas" === t.source;
        }) ? _this2._fetchCategorySchemaSet("LivingAtlas", t) : e;
      });
    }
  }, {
    key: "fetchMembers",
    value: function fetchMembers(t) {
      return this.portal._request(this.url + "/users", t);
    }
  }, {
    key: "getThumbnailUrl",
    value: function getThumbnailUrl(t) {
      var r = this.thumbnailUrl;
      return r && t && (r += "&w=".concat(t)), r;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      throw new r("internal:not-yet-implemented", "PortalGroup.toJSON is not yet implemented");
    }
  }, {
    key: "queryItems",
    value: function queryItems(t, r) {
      var e = s(i, t);
      return parseFloat(this.portal.currentVersion) > 5 ? (e = e || new i(), this.portal._queryPortal("/content/groups/".concat(this.id, "/search"), e, "PortalItem", r)) : (e = e ? e.clone() : new i(), e.query = "group:" + this.id + (e.query ? " " + e.query : ""), this.portal.queryItems(e, r));
    }
  }, {
    key: "_fetchCategorySchemaSet",
    value: function _fetchCategorySchemaSet(t, e) {
      var _this3 = this;

      return this.portal._fetchSelf(this.portal.authMode, !0, e).then(function (t) {
        var o = t.contentCategorySetsGroupQuery;

        if (o) {
          var _t = new i();

          return _t.disableExtraQuery = !0, _t.num = 1, _t.query = o, _this3.portal.queryGroups(_t, e);
        }

        throw new r("portal-group:fetchCategorySchema", "contentCategorySetsGroupQuery value not found");
      }).then(function (o) {
        if (o.total) {
          var _r = o.results[0],
              _s = new i();

          return _s.num = 1, _s.query = "typekeywords:\"".concat(t, "\""), _r.queryItems(_s, e);
        }

        throw new r("portal-group:fetchCategorySchema", "contentCategorySetsGroupQuery group not found");
      }).then(function (t) {
        if (t.total) {
          return t.results[0].fetchData("json", e).then(function (t) {
            var r = t && t.categorySchema;
            return r && r.length ? r : [];
          });
        }

        return [];
      });
    }
  }]);

  return l;
}(e);

t([o()], l.prototype, "access", void 0), t([o({
  type: Date
})], l.prototype, "created", void 0), t([o()], l.prototype, "description", void 0), t([o()], l.prototype, "id", void 0), t([o()], l.prototype, "isInvitationOnly", void 0), t([o({
  type: Date
})], l.prototype, "modified", void 0), t([o()], l.prototype, "owner", void 0), t([o()], l.prototype, "portal", void 0), t([o()], l.prototype, "snippet", void 0), t([o()], l.prototype, "sortField", void 0), t([o()], l.prototype, "sortOrder", void 0), t([o()], l.prototype, "tags", void 0), t([o()], l.prototype, "thumbnail", void 0), t([o({
  readOnly: !0
})], l.prototype, "thumbnailUrl", null), t([o()], l.prototype, "title", void 0), t([o({
  readOnly: !0
})], l.prototype, "url", null), l = t([n("esri.portal.PortalGroup")], l);
var p = l;
export { p as default };